var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle120(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "315.9651126300928 269.0955161193812 16.167797100495875 16.33448388061879",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M323.1,281.43c-1.57-.1-2.55-.88-2.94-2.06-.9-2.72,1.45-6.15,4.32-6.27,1.41-.06,2.53.48,3.24,1.75.74,1.33.43,2.52-.49,3.59-.66.76-1.33,1.57-2.13,2.15-.66.48-1.54.66-2,.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle120);
export default __webpack_public_path__ + "static/media/twinkle-1-20.2cbe4e552e1a8de1cc27575b0042e8d1.svg";
export { ForwardRef as ReactComponent };